import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-close.png'
import _imports_1 from '@/assets/img-fail-connect.png'


const _withScopeId = n => (_pushScopeId("data-v-6ef0939b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-background" }
const _hoisted_2 = { class: "alert-wrapper" }
const _hoisted_3 = { class: "button-close" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "상대방과 연결이 되지 않았나요?", -1))
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 눌러 상대방 호출을 다시 시도할 수 있습니다. ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fail-connect",
  src: _imports_1,
  alt: "재연결 이미지"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsDialogOpen(false))),
          src: _imports_0,
          alt: "닫기 아이콘"
        })
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.AutocallNumber) + "로 전화 연결 후 마지막 호출 내역버튼을", 1),
        _hoisted_6,
        _hoisted_7
      ]),
      _hoisted_8,
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.makeACall(_ctx.AutocallNumber)))
      }, _toDisplayString(_ctx.AutocallNumber) + " 재연결하기", 1)
    ])
  ]))
}